export default __webpack_public_path__ + "static/media/32.c1a6f935.png";